/* global GridController, WebView */

var HRDocPortalEmbeddable = function(options){  
    //This is the "constructor" and we are calling the "super" class contructor  
    GridController.call(this,"iz_doc", {
        directory: "views/portal",
        name: "hrDocPortal",
        searchRecords: {
            visible_employee_portal: true
        },
        joinFetch: [
            { otherTable: "ir_attachment", name: "attach", thisField: "id", otherField: "res_id"}
        ]
    }) ;
    this.options = options;
} ;

HRDocPortalEmbeddable.prototype = Object.create(GridController.prototype);
HRDocPortalEmbeddable.prototype.constructor = HRDocPortalEmbeddable;
/**
 * This is called when the embeddable is loaded with data (typically a view render)
 * 
 * @param {object} data the data given to the embedded instance (for example : the customer)
 */

HRDocPortalEmbeddable.prototype.prepareDataOnEnter = function(data, callback){
    this.api.db.multiread({
        iz_doc_space: { search: {} }
    }, function(err, reads){
        if(err){ return err ;}
        let hrDocSpaceIds = [] ;
        reads.iz_doc_space.forEach(function(space){
            if(space.visible_employee_portal){
                hrDocSpaceIds.push(space.id) ;
            }
        }) ;
        if(data && this.options && this.options.searchfield && data.company_id){
            //if we receive some data, we update the grid search options with a new
            //search criteria
            //the this.options object will be filled from HTML markup
            this.searchOptions.space_id = hrDocSpaceIds ;
            this.searchOptions[this.options.searchfield] = data.company_id;
            this.searchOptions.iz_estab_id = data.iz_estab_id ;
            this.searchOptions.iz_agency_id = data.iz_agency_id ;
        }
        //call the normal function on the super class to continue with standard grid behavior
        GridController.prototype.prepareDataOnEnter.call(this, data, callback) ;        
    }.bind(this)) ;
} ;

HRDocPortalEmbeddable.prototype.onLoadSide = function(ev) {
    var doc = ev.data;
    if(!doc.attach){ return this.viewSide.render() ; }

    this.api.db.multiread({
        iz_doc_settings: { searchFirst: {} }
    }, function(err, reads){
        if(err){ return err ;}
        var dontUseGooglePreview = reads.iz_doc_settings.dont_use_google_preview ;
        var dontUseOfficePreview = reads.iz_doc_settings.dont_use_office_preview ;
        var officeTypes = [
            "application/vnd.ms-powerpoint",
            "application/msword",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ] ;
        var googleTypes = [
            // "image/jpeg", "image/png", "image/bmp", "image/gif", "image/tiff", "image/svg+xml", 
            // "video/webm", "video/mp4", "video/mpeg", "video/3gpp", "video/quicktime", "video/x-msvideo",
            // "video/x-ms-wmv", "video/x-flv", 
            // "text/plain", "application/x-iwork-pages-sffpages",
            // "application/illustrator", "image/vnd.adobe.photoshop", "application/x-photoshop",
            // "application/photoshop", "application/psd", "image/psd",
            // "application/postscript",
            // "application/dwg", "application/dxf", "application/x-autocad", "application/x-dxf", "drawing/x-dxf", "image/vnd.dxf", "image/x-autocad",
            // "application/zip", "application/x-rar-compressed",
        ] ;
        doc.attach.viewAsPdf = false;
        if(doc.attach.file_size > 10*1000*1000){
            //more than 10Mo, don't display preview
            doc.attach.isBigFile = true ;
            this.viewSide.render() ;
        }else{
            if(!dontUseOfficePreview && officeTypes.indexOf(doc.attach.mimetype) !== -1){
                this.api.doc.oneTimePublicUrl(doc.attach.id, function(err, token){
                    if(err){ return console.log("error", err) ;}
                    doc.attach.officeUrl = this.api.options.serverUrl+"/api/public/downloadOneTime?token="+token ;
                    this.viewSide.render() ;
                }.bind(this)) ;
            }else if(!dontUseGooglePreview && (googleTypes.indexOf(doc.attach.mimetype) !== -1 || officeTypes.indexOf(doc.attach.mimetype) !== -1)){
                this.api.doc.oneTimePublicUrl(doc.attach.id, function(err, token){
                    if(err){ return console.log("error", err) ;}
                    doc.attach.googleUrl = this.api.options.serverUrl+"/api/public/downloadOneTime?token="+token ;
                    this.viewSide.render() ;
                }.bind(this)) ;
            }else{
                delete doc.attach.googleUrl ;
                delete doc.attach.officeUrl ;
                doc.attach.viewAsPdf = true;
                this.viewSide.render() ;
            }
        }
    }.bind(this)) ;
};


HRDocPortalEmbeddable.prototype.onDownload = function(ev){
    var doc = ev.data.data ;
    this.view.longTask(function(done){
        this.api.readBinary.download(doc.attach, doc.attach.datas_fname, function(err){
            if(err){ return done(err) ;}
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = HRDocPortalEmbeddable ;